import DOMPurify from "dompurify"
import { InGridImageConfig } from "@/utils/ingridConfig"
import style from "./InGridImageTile.module.css"

type Props = {
  config: InGridImageConfig
}

export default function InGridImageTile({ config }: Props) {
  const spacingStyles = {
    "--ns-ingrid-eyebrow-spacing": `${config.eyebrowSpacing}px`,
    "--ns-ingrid-headline-spacing": `${config.headlineSpacing}px`,
    "--ns-ingrid-copy-spacing": `${config.copySpacing}px`,
    "--ns-ingrid-overlay-image-spacing": `${config.overlayImageSpacing}px`,
    "--ns-ingrid-cta-spacing": `${config.ctaSpacing}px`
  }

  const bgImage = config.image ? (
    <img src={config.image} alt={config.altText} loading="lazy" className={`ns-ingrid-image ${style.image}`} />
  ) : null

  const wrappedBgImage = config.imageLink ? (
    <a href={config.imageLink} className={`ns-ingrid-image-link ${style.imageLink}`}>
      {bgImage}
    </a>
  ) : (
    bgImage
  )

  const overlayImg = config.overlayImage ? (
    <img src={config.overlayImage} alt="" loading="lazy" className={`ns-ingrid-overlay-image ${style.overlayImage}`} />
  ) : null

  const hasContent = config.eyebrow || config.headline || config.copy || config.ctaText || overlayImg

  const sanitizedCopy = config.copy ? DOMPurify.sanitize(config.copy) : ""

  const textContent = (
    <>
      {config.overlayImagePosition === "above_text" && overlayImg}
      {config.eyebrow && <span className="ns-ingrid-eyebrow">{config.eyebrow}</span>}
      {config.headline && <h2 className="ns-ingrid-headline">{config.headline}</h2>}
      {sanitizedCopy && <div className="ns-ingrid-copy" dangerouslySetInnerHTML={{ __html: sanitizedCopy }} />}
      {config.overlayImagePosition === "below_text" && overlayImg}
      {config.ctaText && config.ctaLink && (
        <a href={config.ctaLink} className="ns-ingrid-cta" data-cta-style={config.ctaStyle}>
          {config.ctaText}
        </a>
      )}
    </>
  )

  return (
    <div
      className={`ns-ingrid-tile ns-ingrid-image-tile ${style.tile}`}
      data-layout={config.layout}
      data-tile-height={config.tileHeight}
      data-text-color={config.textColor}
      data-text-align-h={config.textAlignH}
      data-text-align-v={config.textAlignV}
      data-gradient-enabled={config.gradientEnabled}
      data-gradient-direction={config.gradientDirection}
      data-gradient-color={config.gradientColor}
      data-desktop-width={config.desktopWidth}
      data-desktop-height={config.desktopHeight}
      data-mobile-width={config.mobileWidth}
      data-mobile-height={config.mobileHeight}
      style={spacingStyles}
    >
      <div className={style.mediaContainer}>{wrappedBgImage}</div>
      {hasContent && (
        <div className={style.contentContainer}>
          <div className={`ns-ingrid-content ${style.content}`}>{textContent}</div>
        </div>
      )}
    </div>
  )
}
